import { TypographyLevel } from '../typography';
import css from './style.module.css';

export const levelPresets: Record<TypographyLevel, string> = {
  [TypographyLevel.FIRST]: css.first,
  [TypographyLevel.SECOND]: css.second,
  [TypographyLevel.THIRD]: css.third,
};
